<!-- V2 Inline Image Uploader - Seamless Form Integration -->
<div class="v2-image-uploader" [attr.data-section]="sectionTheme">
  
  <!-- Image Upload Field -->
  <div class="form-group">
    <label class="field-label">{{ getImageLabel() }}</label>
    
    <!-- Hidden File Input -->
    <input 
      type="file" 
      #fileInput
      accept="image/*"
      (change)="onFileSelect($event)"
      style="display: none;">
    
    <!-- Image Preview or Upload Area -->
    <div class="image-container">
      
      <!-- Current/Preview Image -->
      <div class="image-preview-area" *ngIf="newImageSrc">
        <img 
          #imagePreview
          [src]="newImageSrc" 
          [alt]="'Preview for ' + uploadRequest?.tagName"
          class="preview-image"
          [class.loading]="!previewImageLoaded"
          (load)="onImageLoad()"
          (error)="onImageError()">
        
        <!-- Loading overlay -->
        <div class="image-loading" *ngIf="!previewImageLoaded">
          <div class="loading-spinner"></div>
          <span>Loading image...</span>
        </div>
        
        <!-- Image Info -->
        <div class="image-info" *ngIf="previewImageLoaded && imageDimensions">
          <span class="image-dimensions">{{ imageDimensions.width }} × {{ imageDimensions.height }}</span>
          <span class="image-size" *ngIf="selectedFile">{{ formatFileSize(selectedFile.size) }}</span>
        </div>
      </div>
    </div>
    
    <!-- Image Actions -->
    <div class="image-actions" *ngIf="newImageSrc">
      <button 
        type="button" 
        class="btn btn-outline" 
        (click)="triggerFileInput()">
        Choose Different Image
      </button>
      
      <button 
        type="button" 
        class="btn btn-secondary" 
        *ngIf="originalImageSrc && hasImageChanged()"
        (click)="restoreOriginal()">
        <span class="btn-icon">↺</span>
        Restore Original
      </button>
    </div>
  </div>

  <!-- File Details (when file selected) -->
  <div class="file-details" *ngIf="selectedFile">
    <div class="detail-row">
      <span class="detail-label">File Name:</span>
      <span class="detail-value">{{ selectedFile.name }}</span>
    </div>
    <div class="detail-row">
      <span class="detail-label">File Size:</span>
      <span class="detail-value">{{ formatFileSize(selectedFile.size) }}</span>
    </div>
    <div class="detail-row" *ngIf="imageDimensions">
      <span class="detail-label">Dimensions:</span>
      <span class="detail-value">{{ imageDimensions.width }} × {{ imageDimensions.height }} pixels</span>
    </div>
  </div>

  <!-- Save/Cancel Actions -->
  <div class="editor-actions">
    <button 
      type="button" 
      class="btn btn-outline cancel-btn" 
      [disabled]="isUploading"
      (click)="cancelUpload()">
      Cancel
    </button>
    <button 
      type="button" 
      class="btn btn-primary save-btn" 
      [disabled]="!hasNewImage() || isUploading"
      (click)="saveImage()">
      <span *ngIf="!isUploading">Update Image</span>
      <span *ngIf="isUploading">Uploading...</span>
    </button>
  </div>

</div> 